import { useEffect, useState } from "react";
import EkasImage from "../../Assets/Images/ekas-image.png";
import {
  capitalizeFirstLetter,
  formatDateSlash,
  getAge,
} from "../Helpers/Utilities/Common";

export default function BirForm(props) {
  const [details, setDetails] = useState([]);

  useEffect(() => {
    setDetails(props.data);
  }, [props?.data]);

  const getFullName = (patient) => {
    if (!patient) return "";
    const { last_name, first_name, middle_name, suffix } = patient;

    // Only include non-empty values and add proper spacing/format
    return [
      last_name,
      ",",
      first_name,
      middle_name && middle_name.trim() && middle_name.toUpperCase() !== "N/A" ? ` ${middle_name}` : "",
      suffix ? ` ${suffix}` : "",
    ]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+,/g, ",") // clean up cases like " ,"
      .trim();
  };

  return (
    <div className="form-page">
      <div id="printablediv" className="display-none">
        <div id="page-1" className="bir-form mt-3">
          <img src={EkasImage} alt="Ekas" className="ekas-img" />
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-hci-name">
              {details?.branch_detail?.branch_name
                ? details?.branch_detail?.branch_name
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-accred-no">
              {details?.branch_detail?.accred_no
                ? details?.branch_detail?.accred_no
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-transaction-no">
              {details?.assessment?.id ? details?.assessment?.id : ""}
            </p>
          </div>
          {details?.patient?.phic_membership_type === "member" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="ekas-patient-pin">
                  {details?.patient?.phic_pin ? details?.patient?.phic_pin : ""}
                </p>
              </div>
            </>
          )}
          {details?.patient?.phic_membership_type === "dependent" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="ekas-patient-pin">
                  {details?.patient?.phic_dependent_pin
                    ? details?.patient?.phic_dependent_pin
                    : ""}
                </p>
              </div>
            </>
          )}
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-member-category">
              {details?.patient?.phic_membership_type
                ? capitalizeFirstLetter(details?.patient?.phic_membership_type)
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-name">{getFullName(details?.patient)}</p>
            {/* <div>
              <div className="d-flex flex-row ekas-name-cont">
                <p className="ekas-name-from">{details.period_from}</p>
                <p className="ekas-name-to">{details.period_to}</p>
              </div>
              <div className="tin-cont">
                <p>{details.payee_tin}</p>
              </div>
              <div className="payee-cont">
                <p className="det-name">{details.payee}</p>
                <p className="det-address">{details.payee_address}</p>
              </div>
              <span className="det-zip-payee">{details.payee_zipcode}</span>
              <div className="tin-payor-cont">
                <p>{details.payor_tin}</p>
              </div>
              <div className="payor-cont">
                <p className="det-name">{details.payor}</p>
                <p className="det-address">{details.payor_address}</p>
              </div>
              <span className="det-zip-payor">{details.payor_zipcode}</span>
            </div> */}
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-age">
              {details?.patient?.birthdate
                ? getAge(details?.patient?.birthdate)
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-contact-no">
              {details?.patient?.contact_no ? details?.patient?.contact_no : ""}
            </p>
          </div>
          {details?.patient?.phic_membership_type === "member" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="ekas-patient-member-type">✔</p>
              </div>
            </>
          )}
          {details?.patient?.phic_membership_type === "dependent" && (
            <>
              <div className="ekas-form-details-cont">
                <p className="ekas-patient-dependent-type">✔</p>
              </div>
            </>
          )}
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-atc">
              {details?.patient?.phic_atc ? details?.patient?.phic_atc : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-performed">✔</p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-date-performed">
              {details?.assessment?.added_on
                ? formatDateSlash(details?.assessment?.added_on)
                : ""}
            </p>
          </div>
          <div className="ekas-form-details-cont">
            <p className="ekas-patient-doc-name">
              {details?.assessment?.doc_name
                ? details?.assessment?.doc_name
                : ""}
            </p>
          </div>
        </div>
        {/* <div id="page-2">
          <img src={BIRP2} alt="" className="" />
        </div> */}
      </div>
    </div>
  );
}
